<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description"
                  :disabled="
                    (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-description" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="numero"
              rules="required"
            >
              <b-form-group label="Número" label-for="v-numero">
                <b-form-input
                  id="v-numero"
                  v-model="form.numero"
                  placeholder="Número"
                  :state="errors.length > 0 ? false : null"
                  data-cy="numero"
                  :disabled="
                    (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-numero" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- logo url -->
          <b-col cols="12">
            <b-form-group
              label="Logo do Banco (Upload ou URL)"
              label-for="v-logo"
            >
              <div class="d-flex align-items-start flex-column flex-md-row">
                <div class="flex-grow-1 w-100 mr-md-1 mb-1 mb-md-0">
                  <b-form-input
                    id="v-logo"
                    v-model="form.logoUrl"
                    placeholder="https://exemplo.com/logo.png ou Data URI"
                    class="mb-1"
                    data-cy="logoUrl"
                    :disabled="
                      (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                        !!form.id) ||
                      (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                    "
                  />
                  <b-form-file
                    placeholder="Escolha uma imagem ou arraste aqui..."
                    drop-placeholder="Solte o arquivo aqui..."
                    accept="image/*"
                    @change="onFileChange"
                    :disabled="
                      (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                        !!form.id) ||
                      (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                    "
                  />
                  <small class="text-muted"
                    >Tamanho máximo: 500KB. Formatos: SVG, PNG, JPG.</small
                  >
                </div>
                <div class="text-center ml-md-1">
                  <b-img
                    v-if="form.logoUrl"
                    :src="form.logoUrl"
                    width="80"
                    height="80"
                    alt="Preview"
                    class="rounded border bg-light p-1"
                    style="object-fit: contain"
                  />
                  <div
                    v-else
                    class="rounded border bg-light d-flex align-items-center justify-content-center"
                    style="width: 80px; height: 80px"
                  >
                    <small class="text-muted">Sem Logo</small>
                  </div>
                </div>
              </div>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_FINAN_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_FINAN_ATUALIZAR')"
            :disable-form="isProcessingFile"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BImg,
  BFormFile
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import mixinsGlobal from '@/mixins'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('bankSettingsModule', {
      bank: (state) => state.bank
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
    BImg,
    BFormFile
  },
  directives: {
    Ripple
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Bancos',
      required,
      isProcessingFile: false,
      form: {
        descricao: '',
        numero: '',
        logoUrl: ''
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.bank))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('bankSettingsModule/resetBank')
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('bankSettingsModule/editBank', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('bankSettingsModule/insertNewBank', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    onFileChange(e) {
      // Bootstrap Vue provides the file(s) in the event or directly as the value
      // We check if e.target.files exists (native) or if e is the file (Vue)
      const file = e.target && e.target.files ? e.target.files[0] : e
      if (!file || !(file instanceof File)) return

      // Limit to 500KB
      if (file.size > 500 * 1024) {
        this.MensagemError('Erro', 'O arquivo deve ser menor que 500KB.')
        if (e.target) e.target.value = ''
        return
      }

      const reader = new FileReader()
      this.isProcessingFile = true
      reader.onload = (f) => {
        this.$set(this.form, 'logoUrl', f.target.result)
        this.isProcessingFile = false
      }
      reader.onerror = () => {
        this.isProcessingFile = false
        this.MensagemError('Erro', 'Falha ao ler o arquivo.')
      }
      reader.readAsDataURL(file)
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        numero: '',
        logoUrl: ''
      }
    }
  }
}
</script>
